import ThemeProvider from '@mui/material/styles/ThemeProvider';
import { useEffect } from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import './App.css';
import AppRoutes from './routes/AppRoutes';
import theme from './theme';
import MainContextProvider from '@context/MainContext';
import clarity from '@microsoft/clarity';

function App() {
	useEffect(() => {
		window.process = {
			...window?.process
		};

		initClarityTracker();
	}, []);

	const initClarityTracker = () => {
		clarity.init(process.env.REACT_APP_CLARITY_KEY || '');
		clarity.consent();
	};

	return (
		<ThemeProvider theme={theme}>
			<GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_RECAPTCHAKEY} scriptProps={{ async: true }}>
				<MainContextProvider>
					<AppRoutes />
				</MainContextProvider>
			</GoogleReCaptchaProvider>
		</ThemeProvider>
	);
}

export default App;
